import { a as __rest } from '../../tslib.es6.esm.js';
import { jsx } from 'react/jsx-runtime';
import meterBarStyles from './MeterBar.styles.esm.js';
import { cn } from '../../utils/cn.esm.js';

const MeterBarMap = new Map([
    ["3Bars", 3],
    ["5Bars", 5],
]);
const MeterBarVoiceOver = new Map([
    [
        "3Bars",
        [
            "Level: Low out of High",
            "Level: Medium out of High",
            "Level: High out of High",
        ],
    ],
    [
        "5Bars",
        [
            "Rating: Poor out of Excellent",
            "Rating: Fair out of Excellent",
            "Rating: Good out of Excellent",
            "Rating: Great out of Excellent",
            "Rating: Excellent out of Excellent",
        ],
    ],
]);
const MeterBar = (_a) => {
    var { color = "brand", inverse = false, level = 1, variant = "3Bars", "aria-label": ariaLabel, className } = _a, props = __rest(_a, ["color", "inverse", "level", "variant", "aria-label", "className"]);
    const calcBarColorLevel = (level, maxLevel) => {
        if (level < 1)
            return "inactive";
        // Find the thresholds for low, medium, high
        const lowThreshold = Math.floor(maxLevel / 3);
        const mediumThreshold = Math.floor((2 * maxLevel) / 3);
        if (level <= lowThreshold) {
            return "low";
        }
        else if (level <= mediumThreshold) {
            return "medium";
        }
        else {
            return "high";
        }
    };
    const maxLevel = MeterBarMap.get(variant);
    const voices = MeterBarVoiceOver.get(variant);
    const levelList = [...Array(maxLevel)].map((_, i) => i + 1);
    const colorLevel = calcBarColorLevel(level, maxLevel);
    const { container: containerClass, first: firstClass, base: baseClass, last: lastClass, } = meterBarStyles({
        inverse,
    });
    return (jsx("div", Object.assign({ className: cn(className, containerClass()), role: "img", "aria-label": ariaLabel !== "" ? ariaLabel : voices[level - 1] }, props, { children: levelList.map((inlineLevel) => {
            const barClass = cn(baseClass(), { [firstClass()]: inlineLevel === 1 }, { [lastClass()]: inlineLevel === maxLevel });
            const colorCase = color === "brand" ? color : colorLevel;
            const dataColor = inlineLevel <= level ? colorCase : "inactive";
            const key = `${inlineLevel}-${color}`;
            return (jsx("span", { "data-color": dataColor, className: barClass, "aria-hidden": "true" }, key));
        }) })));
};
// Add display name for better debugging
MeterBar.displayName = "MeterBar";

export { MeterBar };
